const module = {
  routes: [
    {
      path: '/resources/layers',
      component: () => import('@/modules/layers/pages/index.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
